<template>
  <div class="col-md-12">
    <div class="mt-2">
      <b-card no-body style="border:none !important;">
        <b-tabs pills card vertical>
          <b-tab :title-item-class="'tab-title-class'" disabled title="Filter by" style></b-tab>
          <b-tab title="Presentations" active>
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="Presentation(s)" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in trainingArray"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Word" @click="loadMaterials('Word')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="Word Documents" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in WordFilter"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="PDF" @click="loadMaterials('PDF')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="PDF" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in PDFFilter"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Html Links" @click="loadMaterials('Html')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="Html Links" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in HtmlFilter"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Videos" @click="loadMaterials('Video')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <div class="row mb-3">
                      <div class="col-lg-4 mb-1" v-for="training in VideosFilter" :key="training">
                        <!-- video player starts -->
                        <div class="vd-crd">
                          <video controls>
                            <source :src="'https://odctmis.org'+training.uploadfile" />
                            <source :src="'https://odctmis.org'+training.uploadfile" />Your browser does not support HTML5 video.
                          </video>
                          <h6 class="vid-title">{{training.title}}</h6>
                        </div>
                        <!-- video player ends -->
                      </div>
                    </div>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab disabled title="Filter by Year"></b-tab>
          <b-tab title="2019" @click="loadMaterialsYear('2019')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="2019" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in TwoNineFilter"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="2018" @click="loadMaterialsYear('2018')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="2018" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in TwoEightFilter"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="2017" @click="loadMaterialsYear('2017')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="2017" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in TwoSevenFilter"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>

          <b-tab disabled title="Filter by Type"></b-tab>
          <b-tab title="Pre Training" @click="loadMaterialsType('Pre Training Form')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="Pre Training" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in PreTrainingFilter"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="In Training" @click="loadMaterialsType('In Training Form')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="In Training" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in InTrainingFilter"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Reference Material" @click="loadMaterialsType('Reference Material Form')">
            <b-card-text>
              <div class="col-sm-12">
                <div class="tab-item">
                  <vs-list>
                    <vs-list-header title="Reference Material" color="success"></vs-list-header>
                    <vs-list-item
                      v-for="training in ReferenceMaterial"
                      :title="training.title"
                      :key="training"
                      :subtitle="training.createdAt | formatDate"
                      class="hvr"
                    >
                      <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
      <!-- <vs-pagination :total="30" v-model="currentx"></vs-pagination> -->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>